import React, { useState, useEffect } from 'react';
import moment from 'moment';

import { Modal, Button, Form, Spin, message, Divider, Space, DatePicker, Select } from 'antd';
import { DoubleRightOutlined } from '@ant-design/icons';

import * as ToolRequest from '../../../tools/ToolRequest';

import SpinFull from '../../../components/SpinFull';

const { RangePicker } = DatePicker;
const { Option } = Select;

const formLayout = {
  labelCol: {
    sm: { span: 8 },
  },
  wrapperCol: {
    sm: { span: 16 },
  },
  labelWrap: true,
};

const formTailLayout = {
  wrapperCol: {
    sm: { offset: 8, span: 16 },
  },
};

const api = window.getConfig().apiHost;

export default function StationDashboardGraphDownloadModal(props) {
  const {
    isSensor,
    zoneIoId,
    visible,
    onOk,
    onCancel,
    chartSelectedRange,
    chartSelectedDates,
  } = props;

  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(false);

  const [stationZoneIo, setStationZoneIo] = useState(null);
  const [stationZone, setStationZone] = useState(null);

  const [selectedRange, setSelectedRange] = useState(chartSelectedRange);
  const [selectedDates, setSelectedDates] = useState(chartSelectedDates);

  useEffect(() => {
    (async () => {
      // zone io
      const stationZoneIoRes = await ToolRequest.request('GET', `/v1/station-zone-io/${zoneIoId}`);
      setStationZoneIo(stationZoneIoRes);

      // zone
      const stationZoneRes = await ToolRequest.request('GET', `/v1/station-zone/${stationZoneIoRes.zoneId}`);
      setStationZone(stationZoneRes);

      setLoaded(true);
    })();
  }, []);

  return (
    <Modal
      title="Download Data"
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      width="60%"
      maskClosable={false}
      footer={null}
    >
      {loaded ? (
        <Spin spinning={loading}>
          <Form
            {...formLayout}
          >
            <Form.Item
              label="IO"
            >
              <Space>
                {stationZone.name}
                <DoubleRightOutlined />
                {stationZoneIo.name}
              </Space>
            </Form.Item>

            <Form.Item
              label="Date Range"
            >
              <Space>
                {!selectedRange && (
                  <RangePicker
                    showTime={true}
                    allowClear={false}
                    value={selectedDates}
                    onChange={(dates) => {
                      setSelectedDates(dates);
                    }}
                  />
                )}
                <Select
                  value={selectedRange}
                  onChange={(value) => {
                    setSelectedRange(value);
                    const now = moment().startOf('minute');
                    if (value) {
                      setSelectedDates([moment(now).subtract(value, 'hour'), now]);
                    }
                  }}
                  dropdownMatchSelectWidth={150}
                >
                  <Option value={1}>Past 1 hour</Option>
                  <Option value={4}>Past 4 hours</Option>
                  <Option value={8}>Past 8 hours</Option>
                  <Option value={12}>Past 12 hours</Option>
                  <Option value={24}>Past 24 hours</Option>
                  <Option value={48}>Past 2 days</Option>
                  <Option value={168}>Past 7 days</Option>
                  <Option value={null}>Custom</Option>
                </Select>
              </Space>
            </Form.Item>

            <Form.Item
              {...formTailLayout}
            >
              <Button
                type="primary"
                href={`${api}/v1/station-${isSensor ? 'sensor' : 'control'}-record-export?${new URLSearchParams({
                  zoneId: stationZone.id,
                  ioName: stationZoneIo.name,
                  beginAt: selectedDates[0].toISOString(),
                  endAt: selectedDates[1].toISOString(),
                }).toString()}`}
                target="_blank"
                onClick={(e) => {
                  if (selectedDates[1].diff(selectedDates[0]) > 30 * 24 * 60 * 60 * 1000) {
                    e.preventDefault();
                    return message.error('Date range cannot exceed 30 days');
                  }
                  setLoading(true);
                  onOk();
                }}
                disabled={loading}
              >
                Download
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      ) : <SpinFull />}
    </Modal>
  );
};